import { FunctionComponent } from 'react'
import { useLoaderData, useMatch } from '@tanstack/react-router'
import { arrayToMap } from '../../../utils/data'
import { Typography } from 'antd'

interface IProps {
  agencyId: number
}

const DisplayAgency: FunctionComponent<any> = (props: IProps) => {
  const { agencyId } = props

  const match = useMatch({ strict: false })
  const { agencies } = useLoaderData({ from: match.routeId ?? '/' })

  const agencyMap = arrayToMap(agencies, 'id')

  const agency = agencyMap.get(agencyId)

  if (!agency) return null

  return <Typography.Text style={{ color: 'grey' }} ellipsis={true}>{agency?.name || `Agency ID: ${agencyId}`}</Typography.Text>
}

export default DisplayAgency
